module.exports = __webpack_public_path__ + "1628443000e558584dfc8d7ffc0aba17.jpg";